// packages/content/src/tuning/shop.ts — fruit prices live here (Contract change 1)
import type { TuningBank } from '../schema/tuning';
export default {
  openHour: 8, closeHour: 22, dropBoxRate: 0.8, dailyFurniture: 4, dailyWallpaper: 1, dailyFloor: 1,
  furnitureSellRate: 0.25, always: ['tool.rod', 'tool.shovel', 'paper.plain', 'wrap.plain'],
  nativeFruitSell: 100, foreignFruitSell: 500,
  loanQuickPay: [1000, 10000],                                       // Contract change 23: the loan screen's quick-pay buttons (M1-T14)
} as const satisfies TuningBank;

// Note (Contract change 27): `always` names catalog ids that M1-T01 adds in this same wave. M0-T06's content validator does
// not resolve tuning catalog references (§7.2 "Content validation"), so this task stays green in isolation; resolution is
// checked after the merge by M1-T07's `shop.buy` test (every `alwaysStock()` id has a positive `buyPrice`).
